import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";
import ExternalActivitystream from "../components/activitystreams/ExternalActivitystream";

// Connects to data-controller="external-activitystream"
// Mounts the read-only React activitystream for externally-visible streams
// (browser + app). The app's borderless look follows from .tixxt--in-app CSS.
export default class extends Controller {
  static values = { streamUrl: String };

  connect() {
    // Read-only external page: keep Turbo Drive off so links don't trigger a
    // Turbo visit in the logged-out context. Done here (not via an inline view
    // script) because the bundle that defines window.Turbo is deferred, so an
    // inline `Turbo.session.drive = false` raced it and threw (#142).
    if (window.Turbo) window.Turbo.session.drive = false;

    this.root = createRoot(this.element);
    this.root.render(
      <QueryClientProvider>
        <ExternalActivitystream streamUrl={this.streamUrlValue} />
      </QueryClientProvider>,
    );
  }

  disconnect() {
    this.root?.unmount();
  }
}
